import { colorCss } from "./colorCss";

const OFFSET_FLOAT = 2;
const SHAPE_FLOAT = 3;
const SIZE_FLOAT = 4;
const COLOR_OFFSET = 5;
// MARKER_SHAPE of gl/markerRenderer
const CIRCLE = 0;
const ARROW_UP = 1;
// Depth of the notch in the base of an arrowhead, a share of its half size (as markerRenderer)
const ARROW_NOTCH = 0.5;

const traceShape = (context, shape, x, y, half) => {
  if (shape === CIRCLE) {
    context.arc(x, y, half, 0, Math.PI * 2);
    return;
  }

  const apex = shape === ARROW_UP ? -half : half;

  context.moveTo(x, y + apex);
  context.lineTo(x + half, y - apex);
  context.lineTo(x, y - apex * (1 - ARROW_NOTCH));
  context.lineTo(x - half, y - apex);
  context.closePath();
};

/**
 * Canvas 2D version of markerRenderer.draw: circles and arrowheads of the
 * same size and colours; markers of size 0 (no value) and outside the
 * canvas are skipped.
 *
 * @param {CanvasRenderingContext2D} context
 * @param {Float32Array} instances - [x, y, offset, shape, size, r, g, b, a] per marker
 * @param {number} floatsPerInstance
 * @param {object} params - see markerRenderer.draw
 */
export const paintMarkers = (context, instances, floatsPerInstance, { viewport, xTransform, yTransform, pixelRatio }) => {
  const [xScale, xOffset] = xTransform;
  const [yScale, yOffset] = yTransform;

  for (let offset = 0; offset < instances.length; offset += floatsPerInstance) {
    const half = (instances[offset + SIZE_FLOAT] * pixelRatio) / 2;
    const x = instances[offset] * xScale + xOffset;

    if (half > 0 && x + half >= 0 && x - half <= viewport[0]) {
      const y = instances[offset + 1] * yScale + yOffset + instances[offset + OFFSET_FLOAT] * pixelRatio;

      context.beginPath();
      traceShape(context, instances[offset + SHAPE_FLOAT], x, y, half);
      context.fillStyle = colorCss(instances, offset + COLOR_OFFSET);
      context.fill();
    }
  }
};
